import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';
import useScrollReveal from './hooks/useScrollReveal';
import './index.css';

const navTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

function App() {
  useScrollReveal('.glass-card, .story-block, .highlight-card');

  return (
    <>
      <Navbar navTo={navTo} />
      <main>
        <Hero navTo={navTo} />
        <About />
        <Projects />
        <Skills />
        <Team />
        <Contact />
      </main>
      <Footer navTo={navTo} />
    </>
  );
}

export default App;
